module.exports = __webpack_public_path__ + "img/36192-024.eeb85c37.jpg";